<script setup>
import dayjs from 'dayjs';

const props = defineProps({
  leaves: {
    type: Array,
    required: true,
  },
  company: {
    type: Object,
    required: true,
  },
});

function formatTime(datetime) {
  return dayjs(datetime).format('HH:mm');
}

function formatDate(datetime) {
  return dayjs(datetime).format('DD');
}

function overlapMinutes(begin, end, breakBegin, breakEnd) {
  const overlapStart = begin.isAfter(breakBegin) ? begin : breakBegin;
  const overlapEnd = end.isBefore(breakEnd) ? end : breakEnd;

  if (!overlapEnd.isAfter(overlapStart)) {
    return 0;
  }

  return overlapEnd.diff(overlapStart, 'minute');
}

function leaveHours(leave, company) {
  const begin = dayjs(leave.begin_time);
  const end = dayjs(leave.end_time);
  const rawMinutes = end.diff(begin, 'minute');

  if (!company.break_time || !company.break_time.includes(' - ')) {
    return Math.max(0, Math.floor(rawMinutes / 60));
  }

  const [breakBeginRaw, breakEndRaw] = company.break_time.split(' - ');
  const breakBegin = dayjs(`${begin.format('YYYY-MM-DD')} ${breakBeginRaw}`);
  const breakEnd = dayjs(`${begin.format('YYYY-MM-DD')} ${breakEndRaw}`);

  const deductedMinutes = overlapMinutes(begin, end, breakBegin, breakEnd);
  const effectiveMinutes = Math.max(0, rawMinutes - deductedMinutes);

  return Math.floor(effectiveMinutes / 60);
}
</script>

<template>
  <table v-if="leaves.length" class="w-full overflow-auto border-separate table-auto">
    <thead>
      <tr>
        <th>date</th>
        <th>begin</th>
        <th>end</th>
        <th>
          hours
          <span title="Actual working hours after deducting lunch break." class="cursor-help">&#9432;</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="leave in leaves">
        <tr class="text-center hover:bg-gray-200">
          <td>
            <div class="text-white bg-indigo-400 rounded-full">
              {{ formatDate(leave.begin_time) }}
            </div>
          </td>
          <td>{{ formatTime(leave.begin_time) }}</td>
          <td>{{ formatTime(leave.end_time) }}</td>
          <td>{{ leaveHours(leave, company) }}</td>
        </tr>
      </template>
    </tbody>
  </table>
  <div v-else class="text-center">no data, please try other conditions</div>
</template>
